module.exports = __webpack_public_path__ + "assets/umnazia.ru.725ce08d27abbc47bb086287ed8866b5592c138a86e1a3fae3dfc16e5d7829b1.png";